import React from 'react';
import CTAButton from './CTAButton';
const SidebarCTA = () => {
  return <div className="bg-white border border-gray-200 rounded-lg p-5 sm:p-6 sticky top-6" data-id="element-226">
      <h3 className="text-lg sm:text-xl font-bold text-center mb-4" data-id="element-227">
        Fall Asleep Faster & Sleep Better
      </h3>
      <div className="w-full aspect-square bg-white flex items-center justify-center mb-5 sm:mb-6 rounded-md overflow-hidden" data-id="element-228">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dpvyZYn2w7gZmVyLBmbdWp/FallAsleepNaturally_6.webp" alt="Nymera Sleep Strips product package" className="w-full h-full object-contain" data-id="element-229" />
      </div>
      {/* Customer reviews section */}
      <div className="mb-5 sm:mb-6" data-id="element-230">
        <h4 className="font-medium mb-2" data-id="element-231">Customer Reviews</h4>
        <div className="flex items-center mb-1" data-id="element-232">
          {/* Star rating */}
          <div className="flex text-yellow-400" data-id="element-233">
            <span data-id="element-234">★</span>
            <span data-id="element-235">★</span>
            <span data-id="element-236">★</span>
            <span data-id="element-237">★</span>
            <span data-id="element-238">★</span>
          </div>
          <span className="ml-2 text-xs sm:text-sm font-medium" data-id="element-239">
            4.8 out of 5
          </span>
        </div>
        <p className="text-xs sm:text-sm text-gray-600 mb-3 sm:mb-4" data-id="element-240">
          2,471 customer ratings
        </p>
        {/* Rating distribution */}
        <div className="space-y-1" data-id="element-241">
          <div className="flex items-center" data-id="element-242">
            <span className="text-xs w-8 sm:w-10" data-id="element-243">5 Star</span>
            <div className="flex-1 h-2 mx-1 sm:mx-2 bg-gray-200 rounded" data-id="element-244">
              <div className="bg-yellow-400 h-2 rounded" style={{
              width: '90%'
            }} data-id="element-245"></div>
            </div>
            <span className="text-xs w-6 sm:w-8 text-right" data-id="element-246">90%</span>
          </div>
          <div className="flex items-center" data-id="element-247">
            <span className="text-xs w-8 sm:w-10" data-id="element-248">4 Star</span>
            <div className="flex-1 h-2 mx-1 sm:mx-2 bg-gray-200 rounded" data-id="element-249">
              <div className="bg-yellow-400 h-2 rounded" style={{
              width: '7%'
            }} data-id="element-250"></div>
            </div>
            <span className="text-xs w-6 sm:w-8 text-right" data-id="element-251">7%</span>
          </div>
          <div className="flex items-center" data-id="element-252">
            <span className="text-xs w-8 sm:w-10" data-id="element-253">3 Star</span>
            <div className="flex-1 h-2 mx-1 sm:mx-2 bg-gray-200 rounded" data-id="element-254">
              <div className="bg-yellow-400 h-2 rounded" style={{
              width: '2%'
            }} data-id="element-255"></div>
            </div>
            <span className="text-xs w-6 sm:w-8 text-right" data-id="element-256">2%</span>
          </div>
          <div className="flex items-center" data-id="element-257">
            <span className="text-xs w-8 sm:w-10" data-id="element-258">2 Star</span>
            <div className="flex-1 h-2 mx-1 sm:mx-2 bg-gray-200 rounded" data-id="element-259">
              <div className="bg-yellow-400 h-2 rounded" style={{
              width: '0%'
            }} data-id="element-260"></div>
            </div>
            <span className="text-xs w-6 sm:w-8 text-right" data-id="element-261">0%</span>
          </div>
          <div className="flex items-center" data-id="element-262">
            <span className="text-xs w-8 sm:w-10" data-id="element-263">1 Star</span>
            <div className="flex-1 h-2 mx-1 sm:mx-2 bg-gray-200 rounded" data-id="element-264">
              <div className="bg-yellow-400 h-2 rounded" style={{
              width: '1%'
            }} data-id="element-265"></div>
            </div>
            <span className="text-xs w-6 sm:w-8 text-right" data-id="element-266">1%</span>
          </div>
        </div>
      </div>
      {/* Product info */}
      <div className="mb-5 sm:mb-6" data-id="element-267">
        <h4 className="font-bold text-center mb-3" data-id="element-268">Nymera Sleep Strips</h4>
        <p className="text-xs sm:text-sm text-gray-700 mb-3" data-id="element-269">
          The 15-second solution that helps night shift workers fall asleep
          faster and wake up refreshed.
        </p>
        <div className="bg-yellow-50 border border-yellow-200 rounded p-2 sm:p-3 mb-4" data-id="element-270">
          <p className="text-xs sm:text-sm font-medium text-red-600" data-id="element-271">
            ⚠️ Limited Stock Available - 50% Discount Ends Soon!
          </p>
        </div>
      </div>
      {/* CTA Button */}
      <CTAButton text="CLAIM YOUR 50% DISCOUNT NOW" href="https://trynymera.com/products/nymera-sleep-strips" data-id="element-272" />
    </div>;
};
export default SidebarCTA;